type Props = {};

const Test = (props: Props) => {
  return null;
};

export default Test;
